<template>
  <div class="schedule-empty">
    <div class="schedule-empty__icon">
      <img src="../assets/images/CalendarioConsultas.png" alt="" />
    </div>
    <h3>Calendário de consultas</h3>
    <p>
      Você ainda não possui um calendário definido para os seus atendimentos.
      Configure seus horários de atendimento para começar a receber consultas.
    </p>
    <button class="btn btn--primary" @click.prevent="showForm">
      Criar calendário
    </button>
  </div>
</template>

<script>
export default {
  name: "CreateSchedule",
  props: { openForm: { type: Function, default: null } },
  methods: {
    showForm() {
      if (this.openForm) {
        this.openForm();
      } else {
        this.$store.commit("slot/SET_CREATING_SCHEDULE", true);
        this.$router.push({ name: "ScheduleSettings" });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.schedule-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--space-4);
  padding: var(--space-16) var(--space-6);
  max-width: 480px;
  margin: 0 auto;
}

.schedule-empty__icon {
  width: 88px;
  height: 88px;
  border-radius: var(--radius-full);
  background: var(--color-primary-light);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 56px;
    height: 56px;
    object-fit: contain;
  }
}

.schedule-empty h3 {
  font-size: var(--font-size-xl);
  font-weight: var(--fw-bold);
  color: var(--color-gray-900);
  margin: 0;
}

.schedule-empty p {
  font-size: var(--font-size-sm);
  color: var(--color-gray-500);
  max-width: 360px;
  line-height: 1.6;
  margin: 0;
}
</style>
